/* Forider PDP — rating clickable → scroll a widget Judge.me
   El bloque review (estrellas + nº reviews) al lado del precio
   no linkea por defecto. Aquí lo hacemos clickable. */
(function () {
  const JDGM_SELECTORS = [
    '.jdgm-widget.jdgm-rev-widg',
    '.jdgm-rev-widg',
    '.jdgm-widget',
    '[id*="judgeme_product_reviews"]',
    '[id*="judge-me-reviews"]',
  ];

  const HEADER_OFFSET = 80;

  function findReviewsWidget() {
    for (const sel of JDGM_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function scrollToReviews(e) {
    const target = findReviewsWidget();
    if (!target) return;
    e.preventDefault();
    const top = target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  document.addEventListener('click', (e) => {
    const rating = e.target.closest('.product-details .rating-wrapper');
    if (rating) scrollToReviews(e);
  });

  // Accesibilidad: rol button + Enter/Space
  function enhanceRating() {
    document.querySelectorAll('.product-details .rating-wrapper').forEach((el) => {
      if (el.dataset.foriderEnhanced) return;
      el.dataset.foriderEnhanced = '1';
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Ver reseñas del producto');
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          scrollToReviews(e);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceRating);
  } else {
    enhanceRating();
  }
  // Por si la PDP se hidrata después (section-hydration)
  document.addEventListener('shopify:section:load', enhanceRating);
})();
